// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","453":"d855a71b","455":"4fcfe4c8","457":"571e1486","551":"321e765e","629":"313787bf","851":"05fff0bf","977":"bab33472"}[chunkId] + ".chunk.js";
};